import { render, staticRenderFns } from "./InequalityViz.vue?vue&type=template&id=671d0be3&scoped=true"
import script from "./InequalityViz.vue?vue&type=script&lang=js"
export * from "./InequalityViz.vue?vue&type=script&lang=js"
import style0 from "./InequalityViz.vue?vue&type=style&index=0&id=671d0be3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671d0be3",
  null
  
)

export default component.exports